import { useEffect, useRef } from "react";
import { createPortal } from "react-dom";

const PreLoader = ({ label }) => {
  const elRef = useRef(null);
  if (!elRef.current) {
    elRef.current = document.createElement("div");
  }

  useEffect(() => {
    const modalRoot = document.getElementById("preloader");
    modalRoot.appendChild(elRef.current);
    return () => modalRoot.removeChild(elRef.current);
  }, []);

  return createPortal(
    <div className="loader">
      <div className="loader__figure"></div>
      <p className="loader__label text-center">{label}</p>
    </div>,
    elRef.current,
  );
};

export default PreLoader;
